import { put, all, takeLatest, select } from 'redux-saga/effects';
import actions, { apiActions } from './actions';
import { authTokenSelector } from '../../session';

export function* getPublishers() {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.publisherPortal.publishers.get(authToken));
}

export const sagas = all([
  takeLatest(actions.publisherPortal.publishers.get().type, getPublishers)
]);

function* publisherSagas() {
  yield sagas;
}

export default publisherSagas;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/publisher/sagas.js